export default __webpack_public_path__ + "static/media/banner.84554c4b.png";